const logger = (message: string) => console.error(message);

export default logger;
